const pluralize = require('pluralize')

export default function pluralizeStringUtil (string) {
  // e.g. Superman
  if (/man|woman/gi.test(string)) {
    return string
  }

  return pluralize(string)
}
